(function () {
  'use strict';

  /* ── Custom cursor ──────────────────────────────────────── */
  var dot = document.getElementById('ep-c');
  var ring = document.getElementById('ep-cr');
  if (dot && ring) {
    var mx = 0, my = 0, rx = 0, ry = 0;
    document.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      dot.style.transform = 'translate3d(' + (mx - 5) + 'px,' + (my - 5) + 'px,0)';
    });
    (function animRing() {
      rx += (mx - rx) * .10; ry += (my - ry) * .10;
      ring.style.transform = 'translate3d(' + (rx - 18) + 'px,' + (ry - 18) + 'px,0)';
      requestAnimationFrame(animRing);
    })();
  }

  /* ── Hamburger ──────────────────────────────────────────── */
  var ham = document.getElementById('ep-ham');
  var mobNav = document.getElementById('ep-mob-nav');
  if (ham && mobNav) {
    ham.addEventListener('click', function () {
      var open = ham.classList.toggle('open');
      mobNav.classList.toggle('open', open);
      ham.setAttribute('aria-expanded', open);
      mobNav.setAttribute('aria-hidden', !open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
    mobNav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        ham.classList.remove('open');
        mobNav.classList.remove('open');
        mobNav.setAttribute('aria-hidden', 'true');
        ham.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }

  /* ── Cart drawer ────────────────────────────────────────── */
  var cartBtn = document.getElementById('ep-cart-btn');
  var cartDrawer = document.getElementById('ep-cart-drawer');
  var cartOverlay = document.getElementById('ep-cart-overlay');
  var cartClose = document.getElementById('ep-cart-close');

  function openCart() {
    if (!cartDrawer || !cartOverlay) return;
    cartDrawer.classList.add('open');
    cartOverlay.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeCart() {
    if (!cartDrawer || !cartOverlay) return;
    cartDrawer.classList.remove('open');
    cartOverlay.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (cartBtn) cartBtn.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  function buildCartItem(item) {
    var wrap = document.createElement('div');
    wrap.className = 'ep-cart-item';
    var img = document.createElement('img');
    img.className = 'ep-cart-item__img';
    img.src = item.image ? item.image.replace(/(\.[a-z]+)(\?.*)?$/, '_160x200$1$2') : '';
    img.alt = item.product_title;
    var info = document.createElement('div');
    info.className = 'ep-cart-item__info';
    var name = document.createElement('div');
    name.className = 'ep-cart-item__name';
    name.textContent = item.product_title;
    var meta = document.createElement('div');
    meta.className = 'ep-cart-item__meta';
    meta.textContent = item.variant_title + ' · ' + item.quantity + '×';
    var price = document.createElement('div');
    price.className = 'ep-cart-item__price';
    price.textContent = (item.line_price / 100).toFixed(2).replace('.', ',') + ' €';
    info.appendChild(name); info.appendChild(meta); info.appendChild(price);
    wrap.appendChild(img); wrap.appendChild(info);
    return wrap;
  }

  function refreshCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var countEl = document.getElementById('ep-cart-count');
        if (countEl) countEl.textContent = cart.item_count;
        var body = document.getElementById('ep-cart-body');
        if (body) {
          while (body.firstChild) body.removeChild(body.firstChild);
          if (cart.item_count === 0) {
            var empty = document.createElement('p');
            empty.style.cssText = 'text-align:center;color:var(--muted);font-size:13px;padding:40px 0;';
            empty.textContent = 'Dein Warenkorb ist leer.';
            body.appendChild(empty);
          } else {
            cart.items.forEach(function (item) { body.appendChild(buildCartItem(item)); });
          }
          var totalEl = document.querySelector('.ep-cart-drawer__total-val');
          if (totalEl) totalEl.textContent = (cart.total_price / 100).toFixed(2).replace('.', ',') + ' €';
        }
      })
      .catch(function() {
        var body = document.getElementById('ep-cart-body');
        if (body) {
          var errP = document.createElement('p');
          errP.style.cssText = 'text-align:center;color:var(--muted);font-size:13px;padding:40px 0;';
          errP.textContent = 'Fehler beim Laden. Seite neu laden.';
          while (body.firstChild) body.removeChild(body.firstChild);
          body.appendChild(errP);
        }
      });
  }

  /* ── Add to cart (AJAX) ─────────────────────────────────── */
  document.addEventListener('submit', function (e) {
    if (!e.target.matches('[data-atc-form]')) return;
    e.preventDefault();
    var form = e.target;
    var btn = form.querySelector('[data-atc-btn]');
    var orig = btn ? btn.textContent : '';
    if (btn) { btn.textContent = '…'; btn.disabled = true; }

    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btn) { btn.textContent = '✓ Hinzugefügt'; }
        refreshCart();
        setTimeout(function () {
          openCart();
          if (btn) { btn.textContent = orig; btn.disabled = false; }
        }, 600);
      })
      .catch(function () {
        if (btn) { btn.textContent = orig; btn.disabled = false; }
      });
  });

  /* ── Product gallery + Lightbox ────────────────────────── */
  var mainImg = document.getElementById('ep-main-img');

  // Lightbox erstellen
  var lb = document.createElement('div');
  lb.className = 'ep-lightbox-overlay';
  var lbImg = document.createElement('img');
  var lbClose = document.createElement('button');
  lbClose.className = 'ep-lightbox-close';
  lbClose.setAttribute('aria-label', 'Schließen');
  lbClose.textContent = '✕';
  lb.appendChild(lbImg);
  lb.appendChild(lbClose);
  document.body.appendChild(lb);
  function openLightbox(src) { lbImg.src = src; lb.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeLightbox() { lb.classList.remove('open'); document.body.style.overflow = ''; }
  lbClose.addEventListener('click', closeLightbox);
  lb.addEventListener('click', function(e) { if (e.target === lb) closeLightbox(); });
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeLightbox(); });

  // Hauptbild klickbar (Lightbox)
  var galleryMain = document.querySelector('.ep-gallery__main');
  if (galleryMain) {
    galleryMain.addEventListener('click', function() {
      if (mainImg && mainImg.src) openLightbox(mainImg.src.replace(/_\d+x\d*/, ''));
    });
    galleryMain.style.cursor = 'zoom-in';
  }

  document.querySelectorAll('.ep-gallery__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.ep-gallery__thumb').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (mainImg) {
        mainImg.style.opacity = '0';
        setTimeout(function () {
          mainImg.src = thumb.dataset.src;
          mainImg.style.opacity = '1';
        }, 150);
      }
    });
  });

  /* ── Color swatches ─────────────────────────────────────── */
  document.querySelectorAll('.ep-color').forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      var group = swatch.closest('.ep-colors');
      if (group) group.querySelectorAll('.ep-color').forEach(function (s) { s.classList.remove('active'); });
      swatch.classList.add('active');
      var label = swatch.closest('[data-option-wrap]');
      if (label) {
        var span = label.querySelector('.ep-opts__label span');
        if (span) span.textContent = swatch.dataset.label || '';
      }
      updateVariant();
    });
  });

  /* ── Size selector ──────────────────────────────────────── */
  document.querySelectorAll('.ep-size').forEach(function (sz) {
    sz.addEventListener('click', function () {
      if (sz.classList.contains('sold')) return;
      var group = sz.closest('.ep-sizes');
      if (group) group.querySelectorAll('.ep-size').forEach(function (s) { s.classList.remove('active'); });
      sz.classList.add('active');
      var stickySizes = document.querySelectorAll('.ep-sticky-bar__sz');
      stickySizes.forEach(function (s) { s.classList.toggle('active', s.dataset.val === sz.dataset.val); });
      updateVariant();
    });
  });

  function updateVariant() {
    var activeColor = document.querySelector('.ep-color.active');
    var activeSize  = document.querySelector('.ep-size.active');
    var variantInput = document.getElementById('ep-variant-id');
    if (!variantInput) return;
    var colorVal = activeColor ? activeColor.dataset.c : '';
    var sizeVal  = activeSize  ? activeSize.dataset.val : '';
    var variants = window.epVariants || [];
    var match = variants.find(function (v) {
      var colorMatch = !colorVal || v.options.some(function (o) { return o.toLowerCase().replace(/\s/g,'') === colorVal; });
      var sizeMatch  = !sizeVal  || v.options.includes(sizeVal);
      return colorMatch && sizeMatch;
    });
    if (match) {
      variantInput.value = match.id;
      var priceEl = document.querySelector('.ep-info__price');
      if (priceEl && match.price != null) {
        priceEl.textContent = (match.price / 100).toFixed(2).replace('.', ',') + ' €';
      }
    }
  }

  /* ── Sticky bar ─────────────────────────────────────────── */
  var stickyBar = document.querySelector('.ep-sticky-bar');
  var pdpForm   = document.querySelector('[data-atc-form]');
  if (stickyBar && pdpForm) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('visible', !entry.isIntersecting);
      });
    }, { threshold: 0.1 });
    observer.observe(pdpForm);
  }

  /* ── Accordion ──────────────────────────────────────────── */
  document.querySelectorAll('.ep-acc__head').forEach(function (head) {
    head.addEventListener('click', function () {
      var item = head.closest('.ep-acc__item');
      var wasOpen = item.classList.contains('open');
      document.querySelectorAll('.ep-acc__item').forEach(function (i) { i.classList.remove('open'); });
      if (!wasOpen) item.classList.add('open');
    });
  });

  /* ── Tabs ───────────────────────────────────────────────── */
  document.querySelectorAll('.ep-tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      document.querySelectorAll('.ep-tab').forEach(function (t) { t.classList.remove('active'); });
      document.querySelectorAll('.ep-tab-panel').forEach(function (p) { p.classList.remove('active'); });
      tab.classList.add('active');
      var target = document.getElementById(tab.dataset.tab);
      if (target) target.classList.add('active');
    });
  });

  /* ── Quick-add (collection + featured grid) ────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ep-pcard__add');
    if (!btn) return;
    e.stopPropagation(); e.preventDefault();
    var id = btn.dataset.productId;
    if (!id) return;
    var orig = btn.textContent;
    btn.textContent = '…'; btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = '✓'; btn.style.background = 'var(--gold)';
        refreshCart();
        setTimeout(function () {
          openCart();
          btn.textContent = orig; btn.style.background = '';  btn.disabled = false;
        }, 700);
      })
      .catch(function () { btn.textContent = orig; btn.disabled = false; });
  });

  /* ── Wishlist toggle ────────────────────────────────────── */
  document.querySelectorAll('.ep-pcard__wish').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation(); e.preventDefault();
      var active = btn.classList.toggle('ep-wish-active');
      var svg = btn.querySelector('svg');
      if (svg) svg.setAttribute('fill', active ? 'var(--blush-d)' : 'none');
    });
  });

  /* ── Buy Now ────────────────────────────────────────── */
  var buyBtn = document.getElementById('ep-btn-buy');
  if (buyBtn) {
    buyBtn.addEventListener('click', function () {
      var form = document.querySelector('[data-atc-form]');
      if (!form) { window.location.href = '/checkout'; return; }
      buyBtn.textContent = '…'; buyBtn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () { window.location.href = '/checkout'; });
    });
  }

  /* ── Recommendations API ─────────────────────────────── */
  var recGrid = document.querySelector('.ep-related-grid');
  var productIdMeta = document.querySelector('[data-product-id]');
  if (recGrid && productIdMeta) {
    var pid = productIdMeta.dataset.productId;
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=4')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (!data.products || !data.products.length) return;
        while (recGrid.firstChild) recGrid.removeChild(recGrid.firstChild);
        data.products.forEach(function(p) {
          var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?.*)?$/, '_600x$1$2') : '';
          var card = document.createElement('a');
          card.href = '/products/' + p.handle;
          card.className = 'ep-rel-card';
          var imgWrap = document.createElement('div');
          imgWrap.className = 'ep-rel-card__img';
          var imgEl = document.createElement('img');
          imgEl.src = img;
          imgEl.alt = p.title;
          imgEl.loading = 'lazy';
          imgWrap.appendChild(imgEl);
          var nameEl = document.createElement('div');
          nameEl.className = 'ep-rel-card__name';
          nameEl.textContent = p.title;
          var priceEl = document.createElement('div');
          priceEl.className = 'ep-rel-card__price';
          priceEl.textContent = (p.price / 100).toFixed(2).replace('.', ',') + ' €';
          card.appendChild(imgWrap);
          card.appendChild(nameEl);
          card.appendChild(priceEl);
          recGrid.appendChild(card);
        });
        var lower = document.querySelector('.ep-lower');
        if (lower) lower.style.display = 'block';
      })
      .catch(function() {});
  }

  /* ── Scroll reveal ──────────────────────────────────────── */
  var revealEls = document.querySelectorAll('.ep-reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    var revealObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ep-visible');
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { revealObs.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('ep-visible'); });
  }

  /* ── Magnetic CTA ───────────────────────────────────────── */
  document.querySelectorAll('[data-magnetic]').forEach(function (el) {
    el.addEventListener('mousemove', function (e) {
      var r = el.getBoundingClientRect();
      var x = (e.clientX - r.left - r.width  / 2) * 0.22;
      var y = (e.clientY - r.top  - r.height / 2) * 0.28;
      el.style.transform = 'translate(' + x + 'px,' + y + 'px)';
    });
    el.addEventListener('mouseleave', function () {
      el.style.transform = '';
    });
  });

  /* ── Ripple on buttons ──────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ep-btn-ripple');
    if (!btn) return;
    var r = btn.getBoundingClientRect();
    var size = Math.max(r.width, r.height);
    var ripple = document.createElement('span');
    ripple.className = 'ep-ripple';
    ripple.style.cssText = 'width:' + size + 'px;height:' + size + 'px;'
      + 'left:' + (e.clientX - r.left - size / 2) + 'px;'
      + 'top:'  + (e.clientY - r.top  - size / 2) + 'px;';
    btn.appendChild(ripple);
    setTimeout(function () { ripple.remove(); }, 700);
  });

  /* ── Cursor sparkle trail ───────────────────────────────── */
  if (!window.matchMedia('(pointer: coarse)').matches) {
    var sparkleColors = ['#C9952A','#E8829A','#F2C4CE','#C9952A','#EDE0D8'];
    var lastSparkX = 0, lastSparkY = 0, sparkThrottle = false;
    document.addEventListener('mousemove', function(e) {
      if (sparkThrottle) return;
      var dx = e.clientX - lastSparkX, dy = e.clientY - lastSparkY;
      if (Math.abs(dx) + Math.abs(dy) < 10) return;
      lastSparkX = e.clientX; lastSparkY = e.clientY;
      sparkThrottle = true;
      setTimeout(function(){ sparkThrottle = false; }, 45);
      var s = document.createElement('div');
      s.className = 'ep-sparkle';
      var size = Math.random() * 4 + 3;
      s.style.cssText = 'left:' + e.clientX + 'px;top:' + e.clientY + 'px;'
        + 'width:' + size + 'px;height:' + size + 'px;'
        + 'background:' + sparkleColors[Math.floor(Math.random() * sparkleColors.length)] + ';'
        + 'border-radius:50%;';
      document.body.appendChild(s);
      setTimeout(function(){ if (s.parentNode) s.parentNode.removeChild(s); }, 800);
    });
  }

  /* ── Counter animation ──────────────────────────────────── */
  var counters = document.querySelectorAll('.ep-hero__trust-val');
  if (counters.length && 'IntersectionObserver' in window) {
    var counterObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var raw = el.textContent.trim();
        var num = parseFloat(raw.replace(/[^0-9.]/g, ''));
        if (isNaN(num)) return;
        var suffix = raw.replace(/[0-9.]/g, '');
        var isDecimal = raw.indexOf('.') !== -1;
        var start = 0, duration = 1400, startTime = null;
        function step(ts) {
          if (!startTime) startTime = ts;
          var p = Math.min((ts - startTime) / duration, 1);
          var ease = 1 - Math.pow(1 - p, 3);
          var cur = ease * num;
          el.textContent = (isDecimal ? cur.toFixed(1) : Math.floor(cur)) + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        counterObs.unobserve(el);
      });
    }, { threshold: 0.6 });
    counters.forEach(function(el) { counterObs.observe(el); });
  }

  /* ── Parallax hero ──────────────────────────────────────── */
  var heroImg = document.querySelector('.ep-hero__right img');
  if (heroImg && !window.matchMedia('(pointer: coarse)').matches) {
    var ticking = false;
    window.addEventListener('scroll', function() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function() {
        heroImg.style.transform = 'translateY(' + (window.scrollY * 0.12) + 'px)';
        ticking = false;
      });
    }, { passive: true });
  }

  /* ── Cart icon bounce ───────────────────────────────────── */
  function bounceCart() {
    var cartIcon = document.getElementById('ep-cart-btn');
    if (!cartIcon) return;
    cartIcon.classList.remove('ep-cart-bounce');
    void cartIcon.offsetWidth;
    cartIcon.classList.add('ep-cart-bounce');
    setTimeout(function() { cartIcon.classList.remove('ep-cart-bounce'); }, 700);
  }

  /* ── Size button pop ────────────────────────────────────── */
  document.addEventListener('click', function(e) {
    var sz = e.target.closest('.ep-size');
    if (!sz) return;
    sz.classList.remove('ep-size-pop');
    void sz.offsetWidth;
    sz.classList.add('ep-size-pop');
  });

  /* ── Wishlist heart pulse ───────────────────────────────── */
  document.addEventListener('click', function(e) {
    var wish = e.target.closest('.ep-pcard__wish');
    if (!wish) return;
    wish.classList.remove('ep-wish-pulse');
    void wish.offsetWidth;
    wish.classList.add('ep-wish-pulse');
    setTimeout(function() { wish.classList.remove('ep-wish-pulse'); }, 500);
  });

  /* ── Hook bounce into ATC success ──────────────────────── */
  var _origOpen = openCart;
  openCart = function() {
    bounceCart();
    _origOpen();
  };

})();
